/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelTipoPraticaAttributoEsercenteValoreDTO } from '../model/paged-model-tipo-pratica-attributo-esercente-valore-dto';
// @ts-ignore
import { TipoPraticaAttributoEsercenteValoreCreationForm } from '../model/tipo-pratica-attributo-esercente-valore-creation-form';
// @ts-ignore
import { TipoPraticaAttributoEsercenteValoreDTO } from '../model/tipo-pratica-attributo-esercente-valore-dto';
// @ts-ignore
import { TipoPraticaAttributoEsercenteValorePatchForm } from '../model/tipo-pratica-attributo-esercente-valore-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaAttributoEsercenteValoriControllerServiceInterface,
    CreateTipoPraticaAttributoEsercenteValoreRequestParams,
    DeleteTipoPraticaAttributoEsercenteValoreRequestParams,
    GetTipoPraticaAttributoEsercenteValoreRequestParams,
    ListTipoPraticaAttributoEsercenteValoriRequestParams,
    UpdateTipoPraticaAttributoEsercenteValoreRequestParams
} from './tipo-pratica-attributo-esercente-valori-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaAttributoEsercenteValoriControllerService extends BaseService implements TipoPraticaAttributoEsercenteValoriControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea una nuova opzione catalogata dell\&#39;attributo esercente (CUSTOM_SINGLE_CHOICE / CUSTOM_MULTIPLE_CHOICE)
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public createTipoPraticaAttributoEsercenteValore(requestParameters: CreateTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaAttributoEsercenteValoreDTO>;
    public createTipoPraticaAttributoEsercenteValore(requestParameters: CreateTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaAttributoEsercenteValoreDTO>>;
    public createTipoPraticaAttributoEsercenteValore(requestParameters: CreateTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaAttributoEsercenteValoreDTO>>;
    public createTipoPraticaAttributoEsercenteValore(requestParameters: CreateTipoPraticaAttributoEsercenteValoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling createTipoPraticaAttributoEsercenteValore.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling createTipoPraticaAttributoEsercenteValore.');
        }
        const tipoPraticaAttributoEsercenteValoreCreationForm = requestParameters?.tipoPraticaAttributoEsercenteValoreCreationForm;
        if (tipoPraticaAttributoEsercenteValoreCreationForm === null || tipoPraticaAttributoEsercenteValoreCreationForm === undefined) {
            throw new Error('Required parameter tipoPraticaAttributoEsercenteValoreCreationForm was null or undefined when calling createTipoPraticaAttributoEsercenteValore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi-esercente/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaAttributoEsercenteValoreDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaAttributoEsercenteValoreCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina una opzione dell\&#39;attributo esercente
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori/{idVal}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteTipoPraticaAttributoEsercenteValore(requestParameters: DeleteTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTipoPraticaAttributoEsercenteValore(requestParameters: DeleteTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTipoPraticaAttributoEsercenteValore(requestParameters: DeleteTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTipoPraticaAttributoEsercenteValore(requestParameters: DeleteTipoPraticaAttributoEsercenteValoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling deleteTipoPraticaAttributoEsercenteValore.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling deleteTipoPraticaAttributoEsercenteValore.');
        }
        const idVal = requestParameters?.idVal;
        if (idVal === null || idVal === undefined) {
            throw new Error('Required parameter idVal was null or undefined when calling deleteTipoPraticaAttributoEsercenteValore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi-esercente/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori/${this.configuration.encodeParam({name: "idVal", value: idVal, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di una opzione per id (path consistency: 404 se la chain è rotta)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori/{idVal}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getTipoPraticaAttributoEsercenteValore(requestParameters: GetTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaAttributoEsercenteValoreDTO>;
    public getTipoPraticaAttributoEsercenteValore(requestParameters: GetTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaAttributoEsercenteValoreDTO>>;
    public getTipoPraticaAttributoEsercenteValore(requestParameters: GetTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaAttributoEsercenteValoreDTO>>;
    public getTipoPraticaAttributoEsercenteValore(requestParameters: GetTipoPraticaAttributoEsercenteValoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getTipoPraticaAttributoEsercenteValore.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling getTipoPraticaAttributoEsercenteValore.');
        }
        const idVal = requestParameters?.idVal;
        if (idVal === null || idVal === undefined) {
            throw new Error('Required parameter idVal was null or undefined when calling getTipoPraticaAttributoEsercenteValore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi-esercente/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori/${this.configuration.encodeParam({name: "idVal", value: idVal, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaAttributoEsercenteValoreDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle opzioni dell\&#39;attributo esercente (sort default: ordine, id ASC)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaAttributoEsercenteValori(requestParameters: ListTipoPraticaAttributoEsercenteValoriRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelTipoPraticaAttributoEsercenteValoreDTO>;
    public listTipoPraticaAttributoEsercenteValori(requestParameters: ListTipoPraticaAttributoEsercenteValoriRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelTipoPraticaAttributoEsercenteValoreDTO>>;
    public listTipoPraticaAttributoEsercenteValori(requestParameters: ListTipoPraticaAttributoEsercenteValoriRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelTipoPraticaAttributoEsercenteValoreDTO>>;
    public listTipoPraticaAttributoEsercenteValori(requestParameters: ListTipoPraticaAttributoEsercenteValoriRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaAttributoEsercenteValori.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling listTipoPraticaAttributoEsercenteValori.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listTipoPraticaAttributoEsercenteValori.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi-esercente/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelTipoPraticaAttributoEsercenteValoreDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replace di una opzione (richiede version; value frozen post-pubblicazione)
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}/valori/{idVal}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateTipoPraticaAttributoEsercenteValore(requestParameters: UpdateTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaAttributoEsercenteValoreDTO>;
    public updateTipoPraticaAttributoEsercenteValore(requestParameters: UpdateTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaAttributoEsercenteValoreDTO>>;
    public updateTipoPraticaAttributoEsercenteValore(requestParameters: UpdateTipoPraticaAttributoEsercenteValoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaAttributoEsercenteValoreDTO>>;
    public updateTipoPraticaAttributoEsercenteValore(requestParameters: UpdateTipoPraticaAttributoEsercenteValoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling updateTipoPraticaAttributoEsercenteValore.');
        }
        const idAttr = requestParameters?.idAttr;
        if (idAttr === null || idAttr === undefined) {
            throw new Error('Required parameter idAttr was null or undefined when calling updateTipoPraticaAttributoEsercenteValore.');
        }
        const idVal = requestParameters?.idVal;
        if (idVal === null || idVal === undefined) {
            throw new Error('Required parameter idVal was null or undefined when calling updateTipoPraticaAttributoEsercenteValore.');
        }
        const tipoPraticaAttributoEsercenteValorePatchForm = requestParameters?.tipoPraticaAttributoEsercenteValorePatchForm;
        if (tipoPraticaAttributoEsercenteValorePatchForm === null || tipoPraticaAttributoEsercenteValorePatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaAttributoEsercenteValorePatchForm was null or undefined when calling updateTipoPraticaAttributoEsercenteValore.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/attributi-esercente/${this.configuration.encodeParam({name: "idAttr", value: idAttr, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/valori/${this.configuration.encodeParam({name: "idVal", value: idVal, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaAttributoEsercenteValoreDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaAttributoEsercenteValorePatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
